import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

/**
 * Search param: proklik z notifikace připomínky — řádek aktivity s tímto id
 * se zvýrazní a odscrolluje se na něj. Neplatné hodnoty tiše zahodíme.
 */
const aktivitySearchSchema = z.object({
  highlight: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute("/dashboard/aktivity")({
  validateSearch: (search) => aktivitySearchSchema.parse(search),
  beforeLoad: requirePermissionGuard("hca.crm.read"),
});
